import { render } from "./RentalForm.vue?vue&type=template&id=27823c38"
import script from "./RentalForm.vue?vue&type=script&lang=js"
export * from "./RentalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__